import { z } from "zod";
import { signatureApiErrorSchema } from "../signatureApi/models.js";

export default {
  params: z.object({
    supervisorOrgId: z.string(),
    templateId: z.string(),
  }),
  response: z.union([z.literal(true), signatureApiErrorSchema]),
};
